import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { FavoriteDriversModule } from '../../favorite-drivers';
import { FavoriteDriversDialogComponent } from './favorite-drivers-dialog.component';

@NgModule({
    imports: [CommonModule, MatIconModule, MatDialogModule, MatButtonModule, MatListModule, FavoriteDriversModule],
    exports: [FavoriteDriversDialogComponent],
    declarations: [FavoriteDriversDialogComponent]
})
export class FavoriteDriversDialogModule {}
